<template>
  <div>
    <div @keyup.enter="onClickQueryBtn()">
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="85px"
        size="mini"
      >
        <el-form-item label="查询方式：">
          <el-radio-group v-model="form.queryType">
            <el-radio :label="1">公会名称</el-radio>
            <el-radio :label="2">公会id</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="form.queryType == 1 ? '公会名称：' : '公会id：'">
          <el-input
            v-if="form.queryType == 1"
            v-model="form.name"
            clearable
            style="width: 170px"
          ></el-input>
          <el-input
            v-if="form.queryType == 2"
            v-model="form.gid"
            clearable
            style="width: 170px"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            style="margin-left: 10px"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="guildList"
      border
      @sort-change="changeSort"
      size="small"
      style="width: 966px"
      height="650px"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="guildList.length == 0"
    >
      <el-table-column prop="id" label="id" align="center" width="80">
      </el-table-column>
      <el-table-column label="名称" align="center" width="140">
        <template slot-scope="scope">
          <span
            >{{ scope.row.name }}
            <!-- <a @click="onClickResetBtn(scope.row,'name')" style="text-decoration:none" href="javascript:;">[重置]</a> -->
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="introduction"
        label="介绍"
        align="center"
        width="130"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="announcement"
        label="公告"
        align="center"
        width="130"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="lv"
        label="等级"
        align="center"
        width="70"
      >
      </el-table-column>
      <el-table-column
        sortable="custom"
        label="人数"
        prop="numberOfMember"
        align="center"
        width="75"
      >
        <template slot-scope="scope">
          <span
            >{{ scope.row.numberOfMember }}
            <a
              style="text-decoration: none"
              @click="openGuildMembersDialog(scope.row.id)"
              href="javascript:;"
              >[详情]</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="president" label="会长" align="center" width="100">
        <template slot-scope="scope">
          <span>
            <a
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage(scope.row.presidentUid)"
              href="javascript:;"
              >{{ scope.row.president }}</a
            ></span
          >
        </template>
      </el-table-column>

      <el-table-column
        sortable="custom"
        prop="createdAt"
        label="创建时间"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(Number(scope.row.createdAt)) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="dissolveGuild(scope.row.id, scope.row)"
            >解散</el-button
          >
          <!-- <el-button
              type="primary"
              round
              size="mini"
              @click="openEditFunctionSwitchDialog(false, scope.row)"
              >修改</el-button
            > -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 成员列表框 -->
    <GuildMembersDialog
      v-if="shouldGuildMembersDialogVisible"
      @close="onGuildMembersDialogClosed()"
      :value="valueForGuildMembersDialog"
    ></GuildMembersDialog>
  </div>
</template>
  
  <script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import GuildMembersDialog from "./GuildMembersDialog";

export default {
  data() {
    return {
      shouldGuildMembersDialogVisible: false, // 编辑成员列表框是否应该显示出来
      valueForGuildMembersDialog: null, // 要传递给成员列表框的数据
      guildList: [], // 列表里展示的数据
      form: {
        queryType: 1, // 查询方式（1-公会名称查询 2-公会id查询)
        gid: "",
        name: "", //
        orderBy: "", // 排序字段
        sort: "", // 排序规则
      },
      currentCondition: 0,
    };
  },

  created(e) {
    let gid = this.$route.query.gid;
    if (gid != null) {
      //携带了公会id
      this.form.queryType = 2;
      this.form.gid = gid;
      this.onClickQueryBtn(0, 10);
    } else {
      // 拉取集合
      this.loadGuildList(0, 10);
    }
  },

  components: {
    GuildMembersDialog,
  },

  methods: {
    loadMore() {
      console.log("------loadmore():", this.guildList.length);
      // 只有使用公会名称查询的时候才需要考虑使用
      if (this.currentCondition != 2) {
        this.loadGuildList(this.guildList.length, 10);
      }
    },

    /**
     * 改变排序规则
     */
    changeSort(e) {
      if (e.order != null) {
        this.form.orderBy = e.prop;
        this.form.sort = e.order;
      } else {
        this.form.orderBy = "";
        this.form.sort = "";
      }

      this.loadGuildList(0, 20);
    },

    /**
     * 点击查询按钮
     */
    async onClickQueryBtn(skip, limit) {
      this.currentCondition = this.form.queryType;
      await this.loadGuildList(0, 20);
    },

    /**
     * 拉取集合
     */
    async loadGuildList(skip, limit) {
      let condition = "";
      let value = "";
      // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
      if (skip == 0) {
        this.guildList = [];
      }
      switch (this.currentCondition) {
        case 0: {
          break;
        }
        case 1: {
          condition = "name";
          value = this.form.name;

          break;
        }
        case 2: {
          this.guildList = [];
          condition = "gid";
          value = "" + this.form.gid;
          break;
        }
      }
      console.log("form:", this.form);
      let that = this;
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/guild/getGuildList`,
          {
            skip: skip,
            limit: limit,
            condition: condition,
            value: value,
            orderBy: this.form.orderBy,
            sort: this.form.sort,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.guildList = this.guildList.concat(listInResponse);
    },

    /**
     * 解散公会
     * @param {*} id
     * @param {*} entry
     */
    async dissolveGuild(id, entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认解散id为“${entry.id}”、名称为“${entry.name}”的公会？`
        );

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/guild/dissolveGuild`,
            {
              gid: id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "解散成功",
          type: "success",
        });
        for (let i = 0; i < this.guildList.length; i++) {
          if (this.guildList[i].id == id) {
            this.guildList.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 切换封禁被搜索功能
     */
    async switchForbiddenFunctionsSearched(entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认${entry.forbiddenFunctions.searched ? "封禁" : "解封"}id为“${
            entry.id
          }”、名称为“${entry.name}”的公会的被搜索功能？`
        );
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/guild/disabledGuildFunction`,
            {
              gid: entry.id,
              forbiddenFunction: "selected",
              isOpen: entry.forbiddenFunctions.searched,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          entry.forbiddenFunctions.searched =
            !entry.forbiddenFunctions.searched;
        }
      } catch (e) {
        entry.forbiddenFunctions.searched = !entry.forbiddenFunctions.searched;
      }
    },
    /**
     * 切换封禁修改名称功能
     */
    async switchForbiddenFunctionsUpdateName(entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认${entry.forbiddenFunctions.updateName ? "封禁" : "解封"}id为“${
            entry.id
          }”、名称为“${entry.name}”的公会的修改名称功能？`
        );
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/guild/disabledGuildFunction`,
            {
              gid: entry.id,
              forbiddenFunction: "updateName",
              isOpen: entry.forbiddenFunctions.updateName,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          entry.forbiddenFunctions.updateProfile =
            !entry.forbiddenFunctions.updateProfile;
        }
      } catch (e) {
        entry.forbiddenFunctions.updateProfile =
          !entry.forbiddenFunctions.updateProfile;
      }
    },

    /**
     * 切换封禁修改公告功能
     */
    async switchForbiddenFunctionsUpdateAnnouncement(entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认${
            entry.forbiddenFunctions.updateAnnouncement ? "封禁" : "解封"
          }id为“${entry.id}”、名称为“${entry.name}”的公会的修改公告功能？`
        );
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/guild/disabledGuildFunction`,
            {
              gid: entry.id,
              forbiddenFunction: "updateAnnouncement",
              isOpen: entry.forbiddenFunctions.updateAnnouncement,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          entry.forbiddenFunctions.updateProfile =
            !entry.forbiddenFunctions.updateProfile;
        }
      } catch (e) {
        entry.forbiddenFunctions.updateProfile =
          !entry.forbiddenFunctions.updateProfile;
      }
    },

    /**
     * 点击重置按钮
     */
    async onClickResetBtn(entry, setting) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认"重置"id为“${entry.id}”、名称为“${entry.name}”的公会的${setting}?`
        );
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/guild/resetGuildSetting`,
            {
              gid: entry.id,
              setting: setting,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        for (let i = 0; i < this.guildList.length; i++) {
          if (this.guildList[i].id == resData.data.guild.id) {
            // 回写数据
            this.guildList[i].name = resData.data.guild.name;
            this.guildList[i].announcement = resData.data.guild.announcement;
            this.guildList[i].president = resData.data.guild.president;
            this.guildList[i].numberOfMember =
              resData.data.guild.numberOfMember;
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 跳转到玩家详情界面
     * @param {*} entry
     */
    toRouterPlayerInfoPage(uid) {
      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: { uid: uid, tab: "playerList" },
        }).href,
        "_blank"
      );
    },

    /**
     * 打开编辑对话框
     */
    async openGuildMembersDialog(gid) {
      this.shouldGuildMembersDialogVisible = true;
      this.valueForGuildMembersDialog = {
        gid: gid,
      };
    },

    /**
     * 编辑对话框关闭了
     */
    async onGuildMembersDialogClosed() {
      this.shouldGuildMembersDialogVisible = false;
    },
    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

  